import React from 'react';

const RequiredMarker = ({ obj }) => {
  if (!obj || obj.optional) return null;

    return <span style={{ color: '#32343a' }}> *</span>;
};

export default RequiredMarker;
